/**
 * Library Service — API calls for the question library
 */
class LibraryService {
  static instance = null;
  api = null;

  static getInstance() {
    if (!LibraryService.instance) {
      LibraryService.instance = new LibraryService();
    }
    return LibraryService.instance;
  }

  setApi(api) {
    this.api = api;
  }

  async getThemes(childId = '') {
    try {
      const params = childId ? `?child_id=${childId}` : '';
      const res = await this.api.get(`/library/themes${params}`);
      return res.data.themes || [];
    } catch (e) {
      console.error('Erreur library themes:', e);
      return [];
    }
  }

  async getThemeQuestions(themeId, childId = '') {
    try {
      const params = childId ? `?child_id=${childId}` : '';
      const res = await this.api.get(`/library/themes/${themeId}/questions${params}`);
      return res.data;
    } catch (e) {
      console.error('Erreur library questions:', e);
      return { questions: [], theme_id: themeId, theme_name: '', theme_icon: '' };
    }
  }

  async getQuestion(questionId, childId = '') {
    const params = childId ? `?child_id=${childId}` : '';
    const res = await this.api.get(`/library/question/${questionId}${params}`);
    return res.data;
  }

  async getQuiz(questionId) {
    const res = await this.api.get(`/library/question/${questionId}/quiz`);
    return res.data;
  }

  async completeQuiz(questionId, childId = '') {
    const res = await this.api.post(`/library/question/${questionId}/complete-quiz`, { child_id: childId });
    return res.data;
  }

  async harvestStar() {
    const res = await this.api.post('/library/harvest-star');
    return res.data;
  }

  async getProgressSummary() {
    try {
      const res = await this.api.get('/library/progress-summary');
      return res.data;
    } catch (e) {
      console.error('Erreur library progress:', e);
      return { total_questions: 0, total_completed: 0, uncounted_for_star: 0, next_star_in: 5 };
    }
  }
}

export default LibraryService;
